export namespace IncidentsConfigTypes {
    export const INCIDENTS_ANZEIGE_MANDANT_OPTIONS = 'inc-anzeige';
    
}

